import styled from '@emotion/styled/macro';
import { CardNumberElement } from '@stripe/react-stripe-js';

export const StyledCardNumberElement = styled(CardNumberElement)`
  color: ${({ theme }) => theme.color.black};
  font: normal normal 0.875rem/1.5rem ${({ theme }) => theme.font.gotham};
  padding: 0 1rem;
`;
